const openPopupRazorpay = () => {
    const submit = async ( btn ) =>{
        try{
			const formCheckout = document.querySelector('#learn-press-checkout-form');
			const elNonce = formCheckout.querySelector('input[name="learn-press-checkout-nonce"]');

            const response = await wp.apiFetch( {
                method: 'POST',
                path: 'lp/razorpay/v1/create-payment',
                data : {
					'colorTheme' : LearnPressRazorpay.color_theme,
                    'learn-press-checkout-nonce' : elNonce.value,
                },
            } );
            if( btn ){
                btn.classList.remove('loading');
            }

            const { success, message, options } = response;

            if ( success === true ) {
                const RazorpayHandle = new Razorpay(options);
                RazorpayHandle.open();
                const elemPopup = document.querySelector('.razorpay-container iframe');
                if (elemPopup != null ) {
                    elemPopup.style.maxHeight = '640px';
                }
            } else {
                const elemError = document.querySelector('.learn-press-message.error');
                if ( elemError != null ) {
                    elemError.remove();
                }
                formCheckout.insertAdjacentHTML('afterbegin', `<div class="learn-press-message error">${message}</div>`);
            }

        }catch (e) {
            console.log(e);
        }
    }

    const button = document.querySelector('#learn-press-checkout-place-order');

    if ( ! button ) return;

    button.addEventListener('click', (e) => {
        if ( document.querySelector('#checkout-payment input.gateway-input:checked').value === 'razorpay' ) {
            e.preventDefault();
            button.classList.add('loading');
            submit( button );
        }
    });
}

document.addEventListener('DOMContentLoaded',function(){
    openPopupRazorpay();
});
